import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const ChevronLeft = ({
  size,
  type,
  theme,
  className,
  dataTestId = "chevron-left -icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3086 12.7598C10.569 12.4995 10.569 12.0774 10.3086 11.817L6.49227 8.00063L10.3086 4.18425C10.569 3.9239 10.569 3.50179 10.3086 3.24144C10.0483 2.98109 9.62618 2.98109 9.36583 3.24144L5.07805 7.52922C4.8177 7.78957 4.8177 8.21168 5.07805 8.47203L9.36583 12.7598C9.62618 13.0202 10.0483 13.0202 10.3086 12.7598Z"
    />
  </SVGIcon>
);
